import { array, nullable, object, string } from "superstruct";

import type { ContextBase, PathParamsBase } from "../endpoint/Endpoint.js";
import Endpoint from "../endpoint/Endpoint.js";
import EndpointRouter from "../endpoint/EndpointRouter.js";
import { ProjetSchema } from "../models/Projet.js";
import { type User, UserSchema, UserSerializedSchema } from "../models/User.js";

export default function buildAuthenticatedRouter(
    base: EndpointRouter<PathParamsBase, ContextBase>,
) {
    const router = base.addRouter(
        new EndpointRouter<PathParamsBase, { user: User }>().setContextParser(
            object({ user: UserSchema }),
        ),
    );

    const endpoints = {
        getMe: router.addEndpoint(
            new Endpoint()
                .setMethod("GET")
                .setPath("/me", object({}))
                .setResultParser(UserSerializedSchema),
        ),
        getCurrentProject: router.addEndpoint(
            new Endpoint()
                .setMethod("GET")
                .setPath("/projets/current", object({}))
                .setResultParser(nullable(ProjetSchema)),
        ),
        getProjects: router.addEndpoint(
            new Endpoint()
                .setMethod("GET")
                .setPath("/projets", object({}))
                .setResultParser(array(ProjetSchema)),
        ),
        createProject: router.addEndpoint(
            new Endpoint()
                .setMethod("POST")
                .setPath("/projets", object({}))
                .setResultParser(ProjetSchema)
                .setBodySchema(object({})),
        ),
        joinProject: router.addEndpoint(
            new Endpoint()
                .setMethod("POST")
                .setPath("/projets/join", object({}))
                .setResultParser(ProjetSchema)
                .setBodySchema(object({ code: string() })),
        ),
    };

    return { router, endpoints };
}
